import { render, staticRenderFns } from "./HotelRegistrationComponent.vue?vue&type=template&id=7a2426c4&scoped=true&"
import script from "./HotelRegistrationComponent.vue?vue&type=script&lang=js&"
export * from "./HotelRegistrationComponent.vue?vue&type=script&lang=js&"
import style0 from "./HotelRegistrationComponent.vue?vue&type=style&index=0&id=7a2426c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2426c4",
  null
  
)

export default component.exports